import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  Link,
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
  TextField,
} from "@mui/material";
import { ChangeEvent } from "react";
import { ErrorDetailContainer } from "../../../../api/config";
import { RegistrationRequestIntroductionMethod } from "../../../../api/psc";
import { ErrorParser } from "../../../../components/exports";
import { RegistrationStateType } from "../../context/registrationContext";

type TProps = {
  // The View Action
  handleButtonClick: () => void;
  // The State
  state: RegistrationStateType;
  // State Change Handlers
  handleIntroductionMethodChange: (event: SelectChangeEvent) => void;
  handleNameChange: (event: ChangeEvent<HTMLInputElement>) => void;
  handlePhoneNumberChange: (event: ChangeEvent<HTMLInputElement>) => void;
  handleCompanyNameChange: (event: ChangeEvent<HTMLInputElement>) => void;
  handleWorkFieldChange: (event: ChangeEvent<HTMLInputElement>) => void;
  handleCityChange: (event: ChangeEvent<HTMLInputElement>) => void;
  // Error and handler
  error: ErrorDetailContainer;
  handleCloseSnackBar: () => void;
  inProgress: boolean;
};

export default function StepOne({
  state,
  handleButtonClick,
  handleIntroductionMethodChange,
  handleCompanyNameChange,
  handleNameChange,
  handlePhoneNumberChange,
  handleWorkFieldChange,
  handleCityChange,
  error,
  handleCloseSnackBar,
  inProgress,
}: TProps) {
  return (
    <Stack alignItems="center" spacing={2}>
      <Box
        margin="auto"
        sx={{
          width: { xs: "75%", md: "50%" },
          marginBottom: { xs: "50px", md: "40px" },
        }}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              type="text"
              label="نام و نام‌خانوادگی"
              onChange={handleNameChange}
              value={state.fullName}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              type="tel"
              label="شماره موبایل"
              onChange={handlePhoneNumberChange}
              value={state.contactNumber}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              type="text"
              label="نام شرکت"
              onChange={handleCompanyNameChange}
              value={state.companyName}
            />
          </Grid>
          {state.diactivateSocial === true ? (
            <></>
          ) : (
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel>نحوه آشنایی</InputLabel>
                <Select
                  value={state.introductionMethod ?? ""}
                  label="نحوه آشنایی"
                  onChange={handleIntroductionMethodChange}
                  disabled={state.diactivateSocial}
                >
                  <MenuItem
                    value={RegistrationRequestIntroductionMethod.SALE_OPERATOR}
                  >
                    کارشناسان فروش
                  </MenuItem>
                  <MenuItem
                    value={RegistrationRequestIntroductionMethod.INTERNET}
                  >
                    جستجو در اینترنت
                  </MenuItem>
                  <MenuItem
                    value={RegistrationRequestIntroductionMethod.WORD_OF_MOTH}
                  >
                    معرفی آشنایان
                  </MenuItem>
                  <MenuItem
                    value={RegistrationRequestIntroductionMethod.SOCIAL_MEDIA}
                  >
                    شبکه های اجتماعی
                  </MenuItem>
                  <MenuItem
                    value={RegistrationRequestIntroductionMethod.OTHERS}
                  >
                    دیگر
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>
          )}

          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              type="text"
              label="زمینه فعالیت"
              onChange={handleWorkFieldChange}
              value={state.lineOfWork}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              type="text"
              label="استان"
              onChange={handleCityChange}
              value={state.city}
            />
          </Grid>
          <Grid item xs={12}>
            <ErrorParser error={error} />
          </Grid>
        </Grid>
      </Box>

      <Button
        sx={{ width: { xs: "70%", md: "30%" } }}
        size="large"
        variant="contained"
        onClick={handleButtonClick}
        disabled={inProgress ? true : false}
      >
        ثبت اطلاعات و دریافت مشاوره
      </Button>

      <Link href="http://www.persiansaze.com">بازگشت به سایت</Link>
    </Stack>
  );
}
